import { useQuery } from "@tanstack/react-query";
import { Action } from "../types";
import { get } from "../services/restClient";
import { Endpoint, setEndpoint } from "../services/endpoints";

const getActions = async () => {
    const data = await get<Action[]>(setEndpoint(Endpoint.actions), {
        requireAuth: true,
    });
    return data;
};

export const useGetActions = () => {
    return useQuery({ queryKey: ["action"], queryFn: getActions });
};
